import Gateway from './gateway';
import { GatewayResponse, ProtectedRoute } from '~types/gateway';

import {
    TCreateNewCustomerAPIParams,
    TCreateReleaseEarmarkAPIParams,
    TCustomerDetails,
    TEditCustomerDetailsAPIParams,
    TExportCustomerListingAPIResponse,
    TGetCustomerDetailsAPIParams,
    TGetCustomerFilterAPIParams,
    TGetCustomerFilterAPIResponse,
    TGetCustomerInventoryAPIParams,
    TGetCustomerInventoryAPIResponse,
    TGetCustomerListingAPIParams,
    TGetCustomerListingAPIResponse,
    TGetCustomerTransactionsAPIParams,
    TGetCustomerTransactionsAPIResponse,
} from '~types/feat/customer';
import { TGetReleaseEarmarkListingAPIParams, TGetReleaseEarmarkListingAPIResponse } from '~types/feat/setting';

export abstract class ICustomerGateway extends Gateway {
    abstract getCustomerListing(params: TGetCustomerListingAPIParams): GatewayResponse<TGetCustomerListingAPIResponse>;

    abstract createNewCustomer(params: TCreateNewCustomerAPIParams): GatewayResponse<null>;

    abstract getCustomerDetails(params: TGetCustomerDetailsAPIParams): GatewayResponse<TCustomerDetails>;

    abstract deleteCustomer(params: TEditCustomerDetailsAPIParams): GatewayResponse<null>;

    abstract editCustomerDetails(params: TEditCustomerDetailsAPIParams): GatewayResponse<null>;

    abstract getCustomerTransactions(params: TGetCustomerTransactionsAPIParams): GatewayResponse<TGetCustomerTransactionsAPIResponse>;

    abstract getAllCustomers(params: TGetCustomerFilterAPIParams): GatewayResponse<TGetCustomerFilterAPIResponse>;

    abstract getCustomerInventory(params: TGetCustomerInventoryAPIParams): GatewayResponse<TGetCustomerInventoryAPIResponse>;

    abstract exportCustomerListing(params: ProtectedRoute): GatewayResponse<TExportCustomerListingAPIResponse>;

    abstract createReleaseEarmark(params: TCreateReleaseEarmarkAPIParams): GatewayResponse<null>;

    abstract getReleaseEarmarkListing(params: TGetReleaseEarmarkListingAPIParams): GatewayResponse<TGetReleaseEarmarkListingAPIResponse>;
}
